var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBluetooth(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 120,
    viewBox: "0 0 113 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_727_1605)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M78.2168 83.4097L52.9962 60.0659L78.1667 37.374C79.2338 36.4112 79.8524 35.0339 79.8617 33.5961C79.8722 32.1595 79.2723 30.774 78.2168 29.7961L47.4999 1.36458C46.0029 -0.0185149 43.8267 -0.386409 41.9534 0.427383C40.0825 1.24467 38.8733 3.09113 38.8733 5.13085V46.9463L9.50656 19.5928C7.43873 17.6637 4.18263 17.7766 2.24527 19.8466C0.316076 21.9189 0.432573 25.173 2.5039 27.1009L37.586 59.7795L2.50506 92.4569C0.433738 94.3849 0.317241 97.6389 2.2476 99.7135C3.21686 100.751 4.58687 101.346 6.00581 101.346C7.31059 101.346 8.55361 100.856 9.50656 99.9673L38.8733 72.6139V114.868C38.8733 116.895 40.0709 118.737 41.9232 119.559C42.5849 119.852 43.2862 120.001 44.0096 120.001C45.2818 120.001 46.5038 119.532 47.451 118.68L78.1667 90.9888C79.2338 90.026 79.8524 88.6487 79.8617 87.2121C79.8722 85.7754 79.2723 84.39 78.2168 83.4121V83.4097ZM49.146 49.7101V16.8825L67.1111 33.5123L49.146 49.709V49.7101ZM67.1111 87.1259L49.146 103.323V70.4962L67.1111 87.1259Z",
    fill: "url(#paint0_linear_727_1605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6296 84.4854C95.9842 83.8404 95.9597 82.8043 96.5737 82.129C102.079 76.0658 105.093 68.2701 105.093 59.9995C105.093 51.7288 102.079 43.9332 96.5737 37.8699C95.9609 37.1947 95.9854 36.1585 96.6296 35.5135L99.4232 32.7217C100.126 32.0197 101.273 32.0406 101.944 32.7718C108.765 40.217 112.5 49.816 112.5 59.9995C112.5 70.1818 108.765 79.782 101.944 87.2272C101.274 87.9595 100.126 87.9793 99.4232 87.2772L96.6296 84.4854Z",
    fill: "url(#paint1_linear_727_1605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1294 73.9945C85.5027 73.3681 85.4607 72.3669 86.0316 71.6893C88.7856 68.426 90.2861 64.3314 90.2861 59.9994C90.2861 55.6673 88.7856 51.5727 86.0316 48.3094C85.4607 47.6318 85.5027 46.6306 86.1294 46.0042L88.9347 43.2008C89.6535 42.4824 90.8278 42.5325 91.4918 43.3009C99.7561 52.8603 99.7561 67.136 91.4918 76.6955C90.8278 77.4639 89.6523 77.5139 88.9347 76.7956L86.1294 73.9922V73.9945Z",
    fill: "url(#paint2_linear_727_1605)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.3799 66.3051C80.4901 65.773 81.4885 64.9406 82.2318 63.7426C83.646 61.463 83.646 58.5374 82.2318 56.2566C81.4885 55.0587 80.4901 54.2262 79.3799 53.6942C78.6658 53.3519 77.8107 53.5091 77.2503 54.0691L72.3621 58.9541C71.7843 59.5316 71.7843 60.4665 72.3621 61.0439L77.2503 65.929C77.8107 66.489 78.6658 66.6462 79.3799 66.3039V66.3051Z",
    fill: "url(#paint3_linear_727_1605)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_1605",
    x1: 40.3665,
    y1: 0,
    x2: 40.3665,
    y2: 120.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_727_1605",
    x1: 104.314,
    y1: 32.209,
    x2: 104.314,
    y2: 87.7904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_727_1605",
    x1: 91.66,
    y1: 42.6919,
    x2: 91.66,
    y2: 77.3045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED378"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_727_1605",
    x1: 77.6106,
    y1: 53.5142,
    x2: 77.6106,
    y2: 66.4839,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F89332"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED378"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_727_1605"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 111.628,
    height: 120,
    fill: "white",
    transform: "translate(0.87207)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBluetooth);
export default __webpack_public_path__ + "static/media/Bluetooth.799f8798c487185cb4855046e48813df.svg";
export { ForwardRef as ReactComponent };